import { baseRestService } from "@/utils/baseRestService"
import { Config } from '@/config';

class AgolSyncService extends baseRestService {

  constructor() {
    super()
    this.baseUrl = Config.api.apiServerUrl;
  }

  async CheckAndCreateDbStructure(): Promise<void> {
    return await this.Get(`/api/agol-sync/check-db-structure`);
  }

  async InSituSync(): Promise<void> {
    return await this.Get(`/api/in-situ/agol-sync`);
  }

  async AreaOmogeneaSync(): Promise<void> {
    return await this.Get(`/api/area-omogenea/agol-sync`);
  }

  async AreaBoscoDaSemeSync(): Promise<void> {
    return await this.Get(`/api/area-bosco-da-seme/agol-sync`);
  }
  
  async AreaRaccoltaSync(): Promise<void> {
    return await this.Get(`/api/area-raccolta/agol-sync`);
  }
  
  async AreaSaggioSync(): Promise<void> {
    return await this.Get(`/api/area-saggio/agol-sync`);
  }

  async ClasseDiametricaSync(): Promise<void> {
    return await this.Get(`/api/area-saggio-classe-diametrica/agol-sync`);
  }

  async PiantaCampioneSync(): Promise<void> {
    return await this.Get(`/api/area-saggio-pianta-campione/agol-sync`);
  }

  async PiantaPlusSync(): Promise<void> {
    return await this.Get(`/api/pianta-plus/agol-sync`);
  }
  
  async ExSituSync(): Promise<void> {
    return await this.Get(`/api/ex-situ/agol-sync`);
  }
  
  async AreaSperimentaleSync(): Promise<void> {
    return await this.Get(`/api/area-sperimentale/agol-sync`);
  }

  async AreaSpecieProvenienzaSync(): Promise<void> {
    return await this.Get(`/api/area-specie-provenienza/agol-sync`);
  }

  async PiantaSemeMarzeSync(): Promise<void> {
    return await this.Get(`/api/pianta-seme-marze/agol-sync`);
  }
}

export const agolSyncService = new AgolSyncService();